import {
  alignItems,
  backgroundColor,
  borderRadius,
  display,
  fontSize,
  height,
  justifyContent,
  margin,
  minWidth,
  padding,
  textAlign,
  textColor,
  twCls,
  width,
} from '@/style';
import { defineColorPalette, findClosestNumberInArray } from '../Thermostat';

const HOUR = 60;

export interface ScheduleItem {
  startHour: string;
  startMinute: string;
  startTime: number;
  duration: number;
  setPoint: number;
  key: string;
  entry: { setPoint: number };
}

export interface DayScheduleItemProps {
  item: ScheduleItem;
  onItemClick: (key: string) => void;
}

const gradientFromColor = '#ff0000';
const gradientToColor = '#44c0fe';
const minValue = 5;
const maxValue = 30;

const calcColor = (setPoint: number) => {
  const colorPalette = defineColorPalette(
    gradientFromColor,
    gradientToColor,
    minValue,
    maxValue,
    (maxValue - minValue) / 10,
  );

  const closestIndex = findClosestNumberInArray(
    Object.keys(colorPalette).map((k) => Number(k)),
    setPoint,
  );
  return colorPalette[closestIndex];
};

export const DayScheduleItem = ({ item, onItemClick }: DayScheduleItemProps) => {
  const colors = calcColor(item.setPoint);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <li style={{ flex: `${item.duration} 1 0` }} onClick={() => onItemClick?.(item.key)}>
      <div
        style={{
          background: `linear-gradient(${colors?.currentColor}, ${colors?.lighterColor})`,
        }}
        className={twCls(
          margin('mr-1'),
          height('h-16'),
          borderRadius('rounded'),
          display('flex'),
          justifyContent('justify-center'),
          alignItems('items-center'),
          minWidth('min-w-44px'),
        )}
      >
        <div
          className={twCls(
            borderRadius('rounded-full'),
            backgroundColor('bg-white'),
            fontSize('text-sm'),
            textColor('text-blue-100'),
            padding('p-2'),
            width('w-9'),
            height('h-9'),
            textAlign('text-center'),
          )}
        >
          <span className="after:content-['°']">{item.setPoint}</span>
        </div>
      </div>
      <div className={twCls(fontSize('text-xs'), textColor('text-grey-900'))}>
        {item.startHour.padStart(2, '0')}.{item.startMinute.padStart(2, '0')}
      </div>
    </li>
  );
};
